import BaseAction from '@/actions/base_action.js'

export default class extends BaseAction {
  execute(properties, component) {
    const promise = $tpu.r.checkItems.update(
      properties.cardId,
      properties.checkItemId,
      properties.formData)
    this.executeCardUpdate(promise, properties, component, true)
  }
}
